import { useQueryClient } from "@tanstack/react-query";
import { diaryKeys } from "../../../api/diaryKeys";

const useInvalidateDiaries = () => {
	const queryClient = useQueryClient();

	const invalidateDiaries = (diaryId?: string) => {
		// Invalidate all diary queries
		queryClient.invalidateQueries({
			queryKey: diaryKeys.all,
		});

		// If a specific diary ID is provided, also invalidate that specific diary
		if (diaryId) {
			queryClient.invalidateQueries({
				queryKey: diaryKeys.detail(diaryId),
			});
		}
	};
	return invalidateDiaries;
};

export default useInvalidateDiaries;
